<!--
  功能：功能描述
  作者：missfox
  邮箱：missfoxw@163.com
  时间：2021年09月24日 11:23:26
  版本：v1.0
  修改记录：
  修改内容：
  修改人员：
  修改时间：
-->
<template>
  <div class="nursing">
    <div :class="['shift-tab',isApp?'no-header':'']" v-if="showTab">
      <div class="shift-box">
        <div class="tab-list">
          <div
            v-for="(item ,index) in list"
            :class="[active == index ? 'on' : '', 'tab-item']"
            @click="goTab(item.path,index)"
            :key="index"
          >
            {{item.name}}
          </div>
        </div>
        <div class="add-shift" @click="goAdd">
          <van-icon name="plus" style="margin-right: 8px" />新增
        </div>
      </div>
    </div>
      <router-view   />
  </div>
</template>

<script>
export default {
  // 组件参数 接收来自父组件的数据
  props: {},
  // 局部注册的组件
  components: {},
  // 组件状态值
  data() {
    return {
        isApp:true,
      active:0,
      showTab:true,
      list: [
        {
          path: "nurseShiftExchange",
          name: "护士交班",
        },
        {
          path: "floorShift",
          name: "楼层交班",
        },
      ],
    };
  },
  // 计算属性
  computed: {},
  // 侦听器
  watch: {
      $route: {
        handler: function(val){
            for(let i=0;i<this.list.length;i++){
                if(this.list[i].path==val.name){
                    this.active=i
                    this.showTab = true
                    return
                }
            }
            if(val.name == 'shiftExchangeDetails'){
                this.showTab = false;
                return
            }
            this.showTab = true;

        },
        immediate:true
    }
  },
  // 组件方法
  methods: {
    goTab(path, index) {
      if (this.$route.name == path) return;
      this.active = index;
      this.$router.push({
        name: path,
      });
    },
    goAdd(){
        this.$router.push({
        name: 'addShift',
        query: {
            type:this.active,
            isEdit:false
         }
      });
    },
  },
  created() {
        this.isApp= localStorage.getItem('isApp') === '0'
  },

};
</script>

<style scoped>
.shift-tab {
  width: 100%;
  height: 50px;
  box-sizing: border-box;
  background-color: #fff;
  padding: 0 15px;
  display: flex;
  position: fixed;
  top: 44px;
}

.no-header {
  top: 0px !important;
}
.shift-box {
  width: 100%;
  border-bottom: 1px solid #ebebeb;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.tab-list {
  display: flex;
  height: 100%;
  padding-top: 13px;
  box-sizing: border-box;
}
.tab-item {
  display: flex;
  align-items: center;
  height: 100%;
  margin-right: 40px;
  font-size: 16px;
  position: relative;
}
.add-shift {
  width: 74px;
  height: 32px;
  background-color: #029fd1;
  border-radius: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  color: #fff;
}
.on {
  font-weight: bold;
}
.on::after {
  position: absolute;
  bottom: 0;
  width: 64px;
  height: 2px;
  content: "";
  background-color: #029fd1;
}
</style>



// WEBPACK FOOTER //
// src/components/shiftExchange/shift.vue